import React from 'react';
import { observer, inject } from "mobx-react";
import {Link, Switch, Redirect } from 'react-router-dom';
import { Input, InputFile, SelectInput, Collapsible, DatePicker, InputValidation, Table, Chips, Accordion, Spinner, Pagination , Modal } from '@sogei/react-web-components-catalog'
import { breadcrumbRicevutePegno, breadcrumbRicevutePegnoSecondoLivello, breadcrumbTrasmissionePegno } from '../../assets/breadcrumb';
import i18next from 'i18next';
import { Formik } from 'formik';
import * as Yup from 'yup'
import { AppButton } from '../commons/button';
import { decodeTipologica, scrollToTop } from '../commons/uiUtils';
import { regExpDate, regExpOnlyNumbers } from '../../assets/utils/regexp';
import { tableHeadCancIpotecaSecondoLivello, tableHeadPegniSecondoLivello, tableHeadUnicoSecondoLivello } from '../../assets/tableHeaders';
import { RicevutaFirmataENon } from '../ricevute/ricevutaFirmataENon';
import { DownloadDocumento } from '../ricevute/downloadDocumento';
import { DettaglioButton } from '../ricevute/dettaglioButton';

@inject("rootStore")
@observer
class Dettaglio extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.tipologicaStore = props.rootStore.tipologicaStore;
        this.ricevuteStore = props.rootStore.ricevuteStore;
        this.qualificheStore = props.rootStore.qualificheStore;
        this.tipoPratica = this.qualificheStore.tipoPratica;
    }  

    componentDidMount() {}


    componentWillUnmount() {}

    navigateToDettaglio(ricevuta) {
      this.ricevuteStore.loadAndNavigateToTerzoLivello(ricevuta, this.tipoPratica);
    }

    navigateToAvvisi(avvisi) {
      this.ricevuteStore.loadAndNavigateToAvvisi( this.ricevuteStore.filtriRicercaStored, avvisi, this.tipoPratica);
    }
 
    render() {    

      const dettaglioSecondoLivello = this.ricevuteStore.dettaglioSecondoLivello;

      const statoPraticaRisultato = this.ricevuteStore.statoPraticaRisultato;

      const tableHead = (tableHeader)=>{
        //console.log(tableHeader)
        let thLivello1 = tableHeader.filter(x => x.livello==1 ).map( cellaHeader => {
          const cella = <th style={{verticalAlign:"middle"}} className= {cellaHeader.classNameHeader}  colSpan={cellaHeader.colSpan} rowSpan={cellaHeader.rowSpan}> {i18next.t(cellaHeader.label)} </th>
          return cella;
        })
  
        let thLivello2 = tableHeader.filter(y => y.livello==2 ).map( cellaHeader => {
          const cella = <th style={{verticalAlign:"middle"}} className= {cellaHeader.classNameHeader}  colSpan={cellaHeader.colSpan} rowSpan={cellaHeader.rowSpan}> {i18next.t(cellaHeader.label)} </th>
          return cella;
        })
        
        let output = 
        <>
          <tr> {thLivello1}
        </tr>
        <tr> {thLivello2}
        </tr>
      
        </>
        return output;
    }
  
    const documentIcon = (border, icon, iconStyle, spanSrOnly, onClick,titolo) => {
      let customClass = 'btn btn-light border ' + border;
      let iconCenter = icon + ' ' + iconStyle;
      return <AppButton color="none" spanSrOnly={i18next.t(spanSrOnly)} customClass={customClass} iconCenter={iconCenter} type="button"  onClick={onClick} titleKey='' extraProps={{title:i18next.t(titolo)}}/>
    }
    const avviso = (item) =>{
      if(item.flagAvvisi == '1')
        return <AppButton spanSrOnly="BUTTON_VAI_A_DETTAGLIO" color="outlined-blu" type="button" iconCenter="fas fa-eye" onClick={() => this.navigateToAvvisi(item)} titleKey=''/>
      else
        return undefined
    }
    
  /*const downloadButton = (item,element )=> {
    if(
      (!item.condizione?true:item[element.nomeKeyServizio]==item.condizione) && item[element.file]){
        let downloadParam
        if( item[element.file] instanceof Object ){
          downloadParam = {fileMetaData: item[element.file]};
          
        }
        else{
          downloadParam = {idFile: item[element.file]};
          
        }

    return documentIcon(
      element.warning?
        item[element.nomeKeyServizio] == element.warning ? 'border-warning' : 'border-danger'
        :
        'border-info',
        element.icon,
        element.warning?
        item[element.nomeKeyServizio] == element.warning ? 'icon-warning' : 'icon-danger'
        :
        'icon-info',
        element.spanSrOnly,
        () => {this.ricevuteStore.downloadFile(downloadParam)},
        '')
      }
      else return undefined





    
  }*/
        
      /*const tableHead = (
        <>
          <tr>
              <th style={{verticalAlign:"middle"}} className="text-center text-nowrap">{i18next.t("PROGRESSIVO")}</th>
              <th style={{verticalAlign:"middle"}} className="text-center text-nowrap">{i18next.t("STATO")}</th>
              <th style={{verticalAlign:"middle"}} className="text-center text-nowrap">{i18next.t("PROTOCOLLO_UFFICIO")}</th>
              <th style={{verticalAlign:"middle"}} className="text-center text-nowrap">{i18next.t("NUMERO_PRESENTAZIONE")}</th>
              <th style={{verticalAlign:"middle"}} className="text-center text-nowrap">{i18next.t("NUMERO_GENERALE")}</th>
              <th style={{verticalAlign:"middle"}} className="text-center text-nowrap">{i18next.t("DUPLO")}</th>
              <th style={{verticalAlign:"middle"}} className="text-center text-nowrap">{i18next.t("DUPLO_NEGATIVO")}</th>
          </tr>
        </>
    )
*/

let i = 0;
const bottoneModale = (item,element) =>{
  i=i+1
  const output = item[element.nomeKeyServizio] ? <>
  <Modal labelId="label" containerId={"containerIdModale"+i} title={i18next.t("ANOMALIE_UFFICIO")} body={
    <p>
        {item[element.nomeKeyServizio]}
    </p>
    }>
{" "}
</Modal>           
  <button type="button" className="btn btn-light border border-warning" data-toggle="modal" data-target={"#containerIdModale"+i}  >
    Apri
  </button>  
  </> : " - "
  return output
}
const servizioStatoPratica = (item) =>  {
      
        let colonnaStato;

        if(item.stato==2&&item.esito==2) {
          colonnaStato =  <>
          <Modal labelId="label" containerId="containerIdMotivoRifiuto" title="Motivazione scarto" body={
                <p>
                    {item.motivoRifiuto}
                </p>
                }>
            {" "}
          </Modal>           
          <button type="button" className="btn btn-light border border-danger" data-toggle="modal" data-target="#containerIdMotivoRifiuto">
                {item.descStatoElaborazione}
          </button>             
          </> 
        }
        else if((item.stato==2&&item.esito==3&&!item.duplo)||(item.stato==1&&item.esito==0&&!item.duplo)) {
          colonnaStato =  <>
          <Modal labelId="label" containerId="containerIdStatoPratica" title="Stato pratica" body={
                <p>
                  {statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.esito != 0 ? "Servizio di recupero dello stato non disponibile, si prega di riprovare più tardi." : "Domanda del pegno depositata presso l'ufficio in data: "} <b>{statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.dataRicezione} {statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.statoLavorazione == 1 ? ", in lavorazione" : ""}</b>
                </p>
                }>
            {" "}
          </Modal>           
          <button type="button" className="btn btn-light border" data-toggle="modal" data-target="#containerIdStatoPratica"  onClick={() => this.ricevuteStore.chiamataStatoPratica(item)}>
                {item.descStatoElaborazione}
          </button>             
          </> 
        }
        else {
          colonnaStato= item.descStatoElaborazione;
        }
        return colonnaStato;
      }

      const tableBody = tableHeader =>
  
  {
    if(dettaglioSecondoLivello.esitiSecondoLivello === undefined || dettaglioSecondoLivello.esitiSecondoLivello.length == 0)
     return (<tr><td colSpan="10" key={dettaglioSecondoLivello.esitiSecondoLivello.length}><span>{i18next.t("TABLE_NO_RESULTS")}</span></td></tr>)
    else
   {
     
   const output=  dettaglioSecondoLivello.esitiSecondoLivello.map((item,index) => { return (
      <tr key={'result_'+item.idPratica+'_'+index}>
       {tableHeader.filter(z => z.type!=='td-none').map(element => {
        item.protocolloUfficio = item.protocollo? item.protocollo + '/' + item.annoProtocollo: ''
        item.repertorioRaccolta = item.primoNumeroRepertorio + '/' + item.secondoNumeroRepertorio

        item.registrazione = item.dataRegistrazione?item.dataRegistrazione + (item.serieRegistrazione&&(item.serieRegistrazione? (" Serie=" + item.serieRegistrazione) :'')) + (item.numeroRegistrazione? ("Numero=" + item.numeroRegistrazione):'') +( item.sottoNumeroRegistrazione?(",Sottonumero="+ item.sottoNumeroRegistrazione):''):'-';
        if(item.stato =="2" && item.esito == "2"){
          item.duploNegativo = item.duplo
          }
        if(item.stato == "2" && item.esito == "3"){
          item.duploPositivo = item.duplo
        }
        return <td className={element.classNameCella}>{
          element.type==='text'?item[element.nomeKeyServizio]
          :
          element.type==='dettaglio'? <DettaglioButton item= {item} element = {element}  tipoPratica = {this.tipoPratica} livelloTarget={3}/>
          :
          element.type==='ricevutaFirmataENon'? <RicevutaFirmataENon item={item} element = {element}></RicevutaFirmataENon>
          :
          element.type==='downloadDocumento'? <DownloadDocumento item={item} element = {element}></DownloadDocumento>
          :
          element.type==='avviso'? avviso(item)
          :
          element.type==='servizioStatoPratica'? servizioStatoPratica(item)
          :
          element.type==='bottoneModale'? bottoneModale(item,element)
          :
          undefined
          }
          </td>
        
       })
       } 
      </tr>
  )
  })
  return output;

  
  }

  }
      
    

  
  

        return (
          <div className="container-fluid pr-3 pl-3 pb-3">
           
              <div className="row">              
                <div className="col">
                  <h3>{i18next.t(this.tipoPratica==='MP'?"ELENCO_PEGNI":this.tipoPratica==='CI'?"ELENCO_CANCELLAZIONI":"ELENCO_ADEMPIMENTI")}</h3>
                  <div className='my-4'>
                    <AppButton 
                      color="none"
                      isLinkStyle={true}
                      iconLeft="fas fa-long-arrow-alt-left mr-2"
                      titleKey="BUTTON_TORNA_ELENCO_PRATICHE"
                      onClick={() => this.ricevuteStore.backToPrimoLivello(this.tipoPratica)}
                    />
                  </div>
                  {dettaglioSecondoLivello && (<>
                    <div className='row'>
                      <div className='col'>
                        <p>
                          {this.tipoPratica !== 'CI' &&<strong>{i18next.t("DETTAGLIO_CODICE_INVIO", dettaglioSecondoLivello.ricevuta)}</strong>}
                          {this.tipoPratica === 'CI' &&<strong>{i18next.t("DETTAGLIO_CODICE_INVIO_CI", this.ricevuteStore.filtriRicercaStored.ricevute.timestampInvio,dettaglioSecondoLivello.ricevuta)}</strong>}
                          { this.tipoPratica =='MP'&& dettaglioSecondoLivello.esitiSecondoLivello.length > 0 ? (<><br/><strong>{i18next.t("DETTAGLIO_DOMANDA",dettaglioSecondoLivello.esitiSecondoLivello[0])}</strong></>) : ''}
                          {dettaglioSecondoLivello.ricevuta.serieRegistrazione ? (<><br/><strong>{i18next.t("DETTAGLIO_SERIE",dettaglioSecondoLivello.ricevuta)}</strong></>) : ''}
                        </p>
                        <p></p>
                      </div>
                    </div>
                    <div className='row mt-3'>
                      <div className='col'>
                        <Table tableHead={tableHead(
                          this.tipoPratica === 'MP' ? tableHeadPegniSecondoLivello
                          :
                          this.tipoPratica === 'UN'? tableHeadUnicoSecondoLivello:
                          this.tipoPratica === 'CI'? tableHeadCancIpotecaSecondoLivello:
                           undefined)} tableBody={tableBody(
                          this.tipoPratica === 'MP' ? tableHeadPegniSecondoLivello:
                          this.tipoPratica === 'UN'? tableHeadUnicoSecondoLivello:
                          this.tipoPratica === 'CI'? tableHeadCancIpotecaSecondoLivello:
                           undefined)} tableOptions={['table-header']} />
                      </div>
                    </div>
                  </>)}
                </div>
              </div>
            
          </div>
        ); 
      }
}


export default Dettaglio

export { Dettaglio }

